module.exports = __webpack_public_path__ + "static/b532f243026f11232f584941d4e7935bede4da0ab9ae2c4fff68b81eb48906d2-7b6d9f9cebf0fbc5279f3af0aeebeba3.jpeg";